var organisationAvatar = {
    base: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "black.50",
        "& > span": {
            fontWeight: "700",
            color: "white",
        },
        "& > img": {
            objectFit: "cover",
            textAlign: "center",
        },
    },
    variants: {
        size: {
            sm: {
                width: "50px",
                height: "50px",
                "& > span": {
                    fontSize: "1.5rem",
                },
                "& > img": {
                    width: "50px",
                    height: "50px",
                },
            },
            md: {
                width: "100px",
                height: "100px",
                "& > span": {
                    fontSize: "2.5rem",
                },
                "& > img": {
                    width: "100px",
                    height: "100px",
                },
            },
            lg: {
                width: "150px",
                height: "150px",
                "& > span": {
                    fontSize: "3.5rem",
                },
                "& > img": {
                    width: "150px",
                    height: "150px",
                },
            },
        },
    },
};

export { organisationAvatar };
//# sourceMappingURL=organisation-avatar.js.map
